<template>
  <div>
    <el-row style="margin-bottom: 20px;color: #F56C6C; font-size: 20px; font-weight: bolder;margin-top: 20px;">
      <el-col :xl="3" :lg="5" :md="6">
        <span>
          日期：{{ titleData.DATE }}
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="130">
            <template slot-scope="scope">
              {{ scope.row.PRODUCT_NAME.split(' ').join('-') }}
            </template>
          </el-table-column>
          <el-table-column prop="PIC_URL" label="图片" min-width="45">
            <template slot-scope="scope">
              <img style="width: 80px;height: 80px" :src=scope.row.PIC_URL
                onerror="this.src = 'https://service.linkda.com.cn/productImg.jpg';this.onerror = null" />
            </template>
          </el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="45"></el-table-column>
          <el-table-column prop="PRICE" label="单价" min-width="60"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" min-width="60"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率" min-width="60"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="数量" min-width="80">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COUNT" :placeholder="scope.row.COUNT" @focus="getCount(scope.row)" @change="$_getCount"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="TOTAL_FEE" label="总金额" min-width="60"></el-table-column>
          <el-table-column prop="TOTAL_FEE_BEFORE_TAX" label="不含税总金额" min-width="60"></el-table-column>
          <el-table-column prop="VENDOR_NAME" label="供应商" min-width="80"></el-table-column>
          <el-table-column prop="COMMENT" label="备注" min-width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.COMMENT" :placeholder="scope.row.TMP_COMMENT" @focus="getComment(scope.row)" @change="getCom"></el-input>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px;height:100px">
      <el-col :xl="3" :lg="3" :md="5">
        <span>
          总金额：{{ titleData.TOTAL_FEE }}
        </span>
      </el-col>
      <el-col :xl="{ span: 1, offset: 16 }" :lg="{ span: 1, offset: 13 }" :md="{ span: 1, offset: 9 }">
        <el-button size="small" @click="addProducts()" :disabled="isAddDisabled">新增商品</el-button>
      </el-col>
      <el-col :xl="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 2 }" :md="{ span: 1, offset: 3 }">
        <el-button size="small" @click="cleanShopCar()">清空商品</el-button>
      </el-col>
      <el-col :xl="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 2 }" :md="{ span: 1, offset: 3 }">
        <el-button size="small" :disabled="isDisabled" @click="placeOrder()">下单</el-button>
      </el-col>
    </el-row>
    <!--过了规定时间之后供应商信息-->
    <el-dialog title="订单已截止，请联系采购部人员" :visible.sync="supplierVisible" width="60%" center>
      <p style="font-size:15px;margin-bottom:10px">供应商名称：</p>
      <el-table :data="supplierData" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="SUPPLIER_NAME" label="供应商名称" min-width="50"></el-table-column>
        <el-table-column prop="ORDER_DEADLINE" label="下单截止时间" min-width="60"></el-table-column>
      </el-table>
      <p style="font-size:15px;margin:10px 0">采购部人员：</p>
      <el-table :data="purchaserData" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="NAME" label="联系人" min-width="50"></el-table-column>
        <el-table-column prop="CELLPHONE" label="联系电话" min-width="60"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendRequest()">发送延时请求</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryShopCar, updateCount, updateComment, cleanProduct, placeOrder, deleteProduct,
} from '@/assets/api/purchaseOrderManage';

export default {
  data() {
    return {
      selectValue: '',
      TOTAL_FEE: 0.00,
      supplierVisible: false,
      tableData: [],
      form: {},
      supplierData: [],
      purchaserData: [],
      changeCount: {},
      changeComment: {},
      SUPPLIER_IDs: [],
      // 存储档口相关信息
      titleData: [],
      // 判断单位是否为KG
      isTypeUnit: '',
      isDisabled: false,
      COMMENT: '',
      PRODUCT_COUNT: 0,
    };
  },
  created() {
    this.queryTable();
  },
  computed: {
    isAddDisabled() {
      return JSON.stringify(this.titleData) === '[]';
    },
  },
  methods: {
    // 删除商品
    deleteProduct(row) {
      const data = {
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      deleteProduct(data)
        .then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 点击新增商品触发
    addProducts() {
      this.$store.commit('SET_ADD_BTN_TO_PROJECT', false);
      this.$router.push({ name: 'purchaseAddProduct' });
    },
    // 清控商品
    cleanShopCar() {
      const params = {
        CART_ID: this.titleData.CART_ID,
      };
      cleanProduct(params).then((result) => {
        this.queryTable();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 下单
    placeOrder() {
      // 关账限制
      if (this.$util.isOrderClosed(this.titleData.DATE)) {
        this.$message.show({ text: '该月份已关账，无法下单', type: 'warning' });
        return false;
      }

      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            CART_ID: this.titleData.CART_ID,
          };
          placeOrder(params).then((result) => {
            this.$message.show({ text: '下单成功', type: 'success' });
            this.$store.commit('SET_ADD_BTN_TO_PROJECT', true);
            this.queryTable();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    queryTable() {
      queryShopCar()
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result[1].PRODUCTS_IN_SC.map((item) => Object.assign(item, { COUNT: item.PRODUCT_COUNT }, { TMP_COMMENT: item.COMMENT }, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
            this.titleData = result[0];
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
            this.tableData = [];
            this.TOTAL_FEE = 0.00;
            this.titleData = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 数量@focus
    getCount(row) {
      this.isTypeUnit = row.TYPE_UNIT;
      this.changeCount = {
        DETAIL_ID: row.DETAIL_ID,
      };
    },
    // 数量@change
    $_getCount(count) {
      if (this.isTypeUnit !== 'KG' && this.isTypeUnit !== 'kg' && this.isTypeUnit !== '斤' && this.isTypeUnit !== '公斤') {
        const reg = /^(-?\d+)$/;
        if (!(reg.test(count))) {
          this.$message.show({ text: '单位不是公斤的，只能输入整数', type: 'warning' });
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      } else {
        const reg = /^(-?\d+)(\.\d+)?$/;
        if (!(reg.test(count))) {
          this.$message.show({ text: '请输入数字', type: 'warning' });
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      }
      const data = {
        DETAIL_ID: this.changeCount.DETAIL_ID,
        PRODUCT_COUNT: Number(count),
      };
      updateCount(data)
        .then((result) => {
          this.queryTable();
        }).catch((error) => {
          this.isDisabled = true;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 备注@focus
    getComment(row) {
      this.changeComment = {
        DETAIL_ID: row.DETAIL_ID,
      };
    },
    // 备注@change
    getCom(e) {
      const data = {
        COMMENT: e,
        DETAIL_ID: this.changeComment.DETAIL_ID,
      };
      updateComment(data).then((result) => {
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/shopCar.vue